export default __webpack_public_path__ + "images/PA.fb2d8a9.png";